// extracted by extract-css-chunks-webpack-plugin
module.exports = {"image":"css-3HVN8XD5RI","image_image":"css-3BTTdOArbR","image_caption":"css-3LqdKtMRlb"};